import React, { useEffect, useRef } from 'react';
import { DateTime } from 'luxon';
import { useMediaQuery, useTheme } from '~/lib/bn-material-ui';
import { getIngredientBinGraphRanges } from '~/demo/ingredient-bin-graph-ranges';

export default function Graph({ href, role, onSelectManualBinLevel }) {
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down('sm'));
  const sm = useMediaQuery(theme.breakpoints.down('md'));
  const md = useMediaQuery(theme.breakpoints.down('lg'));

  const levelHistoryRef = useRef();

  function getGraphDateRange({ role }) {
    const [beforeDays, afterDays] = xs ? [4, 3] : sm ? [7, 4] : md ? [14, 5] : [21, 7];

    switch (role) {
    case 'ingredient':
      // const endTime = DateTime.now().startOf('hour').plus({ hours : 2 }).toUTC();
      return {
        start: getIngredientBinGraphRanges().start,
        end: getIngredientBinGraphRanges().end,
      };
    case 'feed':
    default:
      return {
        start: DateTime.now().startOf('day').toUTC().minus({ days: beforeDays }).toISO(),
        end: DateTime.now().endOf('day').plus({ days: afterDays }).toUTC().toISO(),
      };
    }
  }

  useEffect(() => {
    function onSelect(e) {
      if (!e || !e.detail) {
        return;
      }

      const { point } = e.detail;
      if (!point || point.source !== 'manual') {
        return;
      }

      onSelectManualBinLevel(point);
    }

    if (levelHistoryRef?.current) {
      const { current } = levelHistoryRef;
      current.addEventListener('bn:select-data-point', onSelect);
      return () => current.removeEventListener('bn:select-data-point', onSelect);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isIngredientBin = role === 'ingredient';
  const contentLabel = isIngredientBin ? 'inventory' : 'feed';
  const showInventoryPeriods = isIngredientBin;

  return (
    <bin-level-smooth-history-graph
      href={href}
      {...getGraphDateRange({ role })}
      content-label={contentLabel}
      forecast
      ref={levelHistoryRef}
      show-inventory-periods={showInventoryPeriods || null}
    />
  );
}
